// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25DiI","productName":"Table_productName__ZvJJ7"};